export default __webpack_public_path__ + "static/media/921.12b13c8e.png";